import SideImage from './SideImage';

export default SideImage;
